// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"UserProfile_overlayWrapper__IuJPg","viewBox":"UserProfile_viewBox__kaDeg"};